import { Component, OnInit, RendererFactory2 } from "@angular/core";
@Component({
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss']
})
export class SplashScreenComponent implements OnInit {
  showSplash = true;
  private renderer: any;
  constructor(
    private rendererFactory: RendererFactory2
  ) { }

  removePreloader() {
    this.renderer = this.rendererFactory.createRenderer(null, null);
    let loader = this.renderer.selectRootElement('#preRenderLoader');
    this.renderer.setStyle(loader, 'display', 'none');;
  }

  ngOnInit(): void {
    this.removePreloader()
    setTimeout(() => {
      this.showSplash = !this.showSplash;

    }, 3000);
  }

}